<!--
 * @Author: Yran
 * @Date: 2021-04-25 16:20:13
 * @LastEditors: Yran
 * @LastEditTime: 2021-05-11 15:43:25
-->
<template>
  <div class="calendar-box" :style="{ width: calendarWidth, height: calendarHeight }">
    <a-calendar v-model:value="valueTime" :fullscreen="false">
      <template #headerRender="{ value, type, onChange, onTypeChange }">
        <div style="padding: 0.3rem">
          <a-row type="flex" style="line-height:32px">
            <span class="disNone">{{ type + onTypeChange }}</span>
            <a-col :span="6">
              <a-select size="small" :dropdown-match-select-width="false" class="my-year-select" :value="String(value.year())" @change="newYear => onChange(value.clone().year(newYear))">
                <a-select-option v-for="val in getYears(value)" :key="String(val)" class="year-item">
                  {{ val }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="6">
              <a-select size="small" :dropdown-match-select-width="false" :value="String(value.month())" @change="selectedMonth => onChange(value.clone().month(parseInt(selectedMonth, 10)))">
                <a-select-option v-for="(val, index) in getMonths(value)" :key="String(index)" class="month-item">
                  {{ val }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col v-if="showResetBtn" :span="12" class="align-r">
              <a-button style="z-index: 3" @click="resetBtnClick" :disabled="tableLoading">重置日期</a-button>
            </a-col>
          </a-row>
        </div>
      </template>
      <template #dateCellRender="{ current: record }">
        <div v-if="getListData(record)" class="selectDays">
          {{ formatDate(record.date()) }}
        </div>
      </template>
    </a-calendar>
    <div class="mark-box"></div>
  </div>
</template>
<script>
import moment from 'moment';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
export default {
  props: {
    // 时间显示范围
    dateArr: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 日历宽度
    calendarWidth: {
      type: String,
      default: '300px',
    },
    // 日历高度
    calendarHeight: {
      type: String,
      default: '320px',
    },
    // 是否显示重置日期按钮
    showResetBtn: {
      type: Boolean,
      default: false,
    },
    // 重置日期
    onResetBtnClick: {
      type: Function,
      default: () => {},
    },
    // 正在加载
    tableLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      locale,
      // 选择的时间
      valueTime: moment(),
      // 显示的日期范围
      selectDate: [],
    };
  },
  mounted() {
    this.selectDate = this.dateArr;
  },
  watch: {
    dateArr(newVal) {
      this.selectDate = newVal;
      this.valueTime = this.selectDate[0] ? moment(this.selectDate[0]) : moment();
    },
  },
  methods: {
    /** 日期渲染
     * @param {Moment} value 渲染的日期
     * @return {*}
     */
    getListData(value) {
      if (this.selectDate.length === 2 && value.format('YYYY-MM-DD') >= this.selectDate[0] && value.format('YYYY-MM-DD') <= this.selectDate[1]) {
        return true;
      } else {
        return false;
      }
    },
    /** 格式化时间文字
     * @param {String} value 需要格式化的时间文字
     * @return {*}
     */
    formatDate(value) {
      return value < 10 ? '0' + value : value;
    },
    /** 获取月份
     * @param {*} value 选中的月份
     * @return {*}
     */
    getMonths(value) {
      const current = value.clone();
      const localeData = value.localeData();
      const months = [];
      for (let i = 0; i < 12; i++) {
        current.month(i);
        months.push(localeData.monthsShort(current));
      }
      return months;
    },
    /** 获取年份列表
     * @param {*} value 选中的年份
     * @return {*}
     */
    getYears(value) {
      const year = value.year();
      const years = [];
      for (let i = year - 10; i < year + 10; i += 1) {
        years.push(i);
      }
      return years;
    },
    resetBtnClick() {
      // eslint-disable-next-line
      this.$emit('onResetBtnClick');
    },
  },
};
</script>
<style lang="less">
.calendar-box {
  min-width: 200px;
  position: relative;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  .ant-fullcalendar-date {
    position: relative;
  }
  .selectDays {
    width: 24px;
    height: 24px;
    margin: 0 auto;
    border-radius: 4px;
    color: #fff;
    background: #1890ff;
  }
  .ant-fullcalendar-content {
    position: absolute;
    top: 0;
    left: 0;
  }
  .mark-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
  .ant-fullcalendar-cell.ant-fullcalendar-today.ant-fullcalendar-selected-day {
    .ant-fullcalendar-value {
      color: rgba(0, 0, 0, 0.85);
      background: #fff;
    }
  }
  .ant-fullcalendar-header {
    text-align: left;
    padding-left: 20px;
    .ant-radio-group.ant-radio-group-outline.ant-radio-group-small {
      display: none;
    }
  }
  .ant-fullcalendar-calendar-body {
    padding: 0.24rem 0.36rem;
  }
}
</style>